// extracted by mini-css-extract-plugin
module.exports = {"modelSwiper":"CapsuleStyleVenue_modelSwiper__lxaWx","productScroller":"CapsuleStyleVenue_productScroller__0M5SI","wapProductSwiper":"CapsuleStyleVenue_wapProductSwiper__Ph5g4"};